export default __webpack_public_path__ + "static/media/11.52fba2c1.png";